(function () {
  'use strict';

  function initReveal() {
    var items = document.querySelectorAll('.mt-reveal');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    items.forEach(function (el) { obs.observe(el); });
  }

  function initPasosSticky() {
    document.querySelectorAll('.mt-pasos-wrap').forEach(function (wrap) {
      var visual = wrap.querySelector('.mt-pasos-visual');
      var pasos = wrap.querySelectorAll('.mt-paso-item');
      if (!pasos.length) return;
      if (!('IntersectionObserver' in window)) return;
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var idx = entry.target.getAttribute('data-paso-index');
          if (entry.isIntersecting) {
            entry.target.classList.add('mt-paso-en-vista');
            if (visual) {
              var imgs = visual.querySelectorAll('img');
              imgs.forEach(function (img) {
                img.classList.toggle('mt-paso-activo', img.getAttribute('data-paso-index') === idx);
              });
            }
          } else {
            entry.target.classList.remove('mt-paso-en-vista');
          }
        });
      }, { threshold: 0.5, rootMargin: '-15% 0px -15% 0px' });
      pasos.forEach(function (p) { obs.observe(p); });
    });
  }

  function initComparador() {
    document.querySelectorAll('.mt-comparador-slider').forEach(function (slider) {
      var despues = slider.querySelector('.mt-comparador-despues');
      var handle = slider.querySelector('.mt-comparador-handle');
      if (!despues || !handle) return;
      var dragging = false;

      function setPos(clientX) {
        var rect = slider.getBoundingClientRect();
        var pct = ((clientX - rect.left) / rect.width) * 100;
        pct = Math.max(0, Math.min(100, pct));
        despues.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
        handle.style.left = pct + '%';
      }

      handle.addEventListener('pointerdown', function (e) {
        dragging = true;
        handle.setPointerCapture(e.pointerId);
      });
      handle.addEventListener('pointerup', function () { dragging = false; });
      handle.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        setPos(e.clientX);
      });
      slider.addEventListener('click', function (e) {
        if (e.target === handle) return;
        setPos(e.clientX);
      });
    });
  }

  function initFaq() {
    document.querySelectorAll('.mt-faq-item').forEach(function (item) {
      var btn = item.querySelector('.mt-faq-pregunta');
      var respuesta = item.querySelector('.mt-faq-respuesta');
      if (!btn || !respuesta) return;
      btn.addEventListener('click', function () {
        var abierto = item.classList.contains('mt-abierto');
        item.closest('.mt-faq-wrap').querySelectorAll('.mt-faq-item').forEach(function (otro) {
          otro.classList.remove('mt-abierto');
          otro.querySelector('.mt-faq-respuesta').style.maxHeight = null;
        });
        if (!abierto) {
          item.classList.add('mt-abierto');
          respuesta.style.maxHeight = respuesta.scrollHeight + 40 + 'px';
        }
      });
    });
  }

  function initGaleriaProducto() {
    document.querySelectorAll('.mt-producto-galeria').forEach(function (galeria) {
      var principal = galeria.querySelector('.mt-producto-galeria-principal img');
      var minis = galeria.querySelectorAll('.mt-producto-miniatura');
      if (!principal || !minis.length) return;
      minis.forEach(function (mini) {
        mini.addEventListener('click', function () {
          var full = mini.getAttribute('data-full');
          if (!full) return;
          principal.src = full;
          minis.forEach(function (m) { m.classList.remove('mt-activa'); });
          mini.classList.add('mt-activa');
        });
      });
    });
  }

  function initVariantes() {
    document.querySelectorAll('[data-mt-producto-form]').forEach(function (form) {
      var dataEl = form.querySelector('[data-mt-variantes-json]');
      if (!dataEl) return;
      var variantes;
      try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var selects = form.querySelectorAll('[data-mt-opcion-index]');
      var idInput = form.querySelector('input[name="id"]');
      var precioEl = form.querySelector('[data-mt-precio]');
      var precioAntesEl = form.querySelector('[data-mt-precio-antes]');
      var btnComprar = form.querySelector('[data-mt-comprar]');
      var stockEl = form.querySelector('[data-mt-stock]');

      function actual() {
        var seleccion = [];
        selects.forEach(function (group) {
          var activo = group.querySelector('.mt-activo');
          seleccion.push(activo ? activo.getAttribute('data-valor') : null);
        });
        return variantes.find(function (v) {
          return v.opciones.every(function (op, i) { return op === seleccion[i]; });
        });
      }

      function actualizar() {
        var variante = actual();
        if (!variante) return;
        if (idInput) idInput.value = variante.id;
        if (precioEl) precioEl.textContent = variante.precio;
        if (precioAntesEl) {
          if (variante.precioAntes) {
            precioAntesEl.textContent = variante.precioAntes;
            precioAntesEl.style.display = '';
          } else {
            precioAntesEl.style.display = 'none';
          }
        }
        if (btnComprar) {
          btnComprar.disabled = !variante.disponible;
          btnComprar.textContent = variante.disponible ? btnComprar.getAttribute('data-texto-disponible') : btnComprar.getAttribute('data-texto-agotado');
        }
        if (stockEl) {
          stockEl.textContent = variante.disponible ? stockEl.getAttribute('data-texto-disponible') : stockEl.getAttribute('data-texto-agotado');
          stockEl.classList.toggle('mt-agotado', !variante.disponible);
        }
      }

      selects.forEach(function (group) {
        group.querySelectorAll('.mt-swatch').forEach(function (btn) {
          btn.addEventListener('click', function () {
            if (btn.disabled) return;
            group.querySelectorAll('.mt-swatch').forEach(function (b) { b.classList.remove('mt-activo'); });
            btn.classList.add('mt-activo');
            actualizar();
          });
        });
      });

      actualizar();
    });
  }

  function initAll() {
    initReveal();
    initPasosSticky();
    initComparador();
    initFaq();
    initGaleriaProducto();
    initVariantes();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
